import { Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Order } from '../order.model';
import { IconComponent } from '../../../shared/icon/icon.component';

@Component({
  selector: 'app-order-deleted',
  standalone: true,
  imports: [IconComponent, DatePipe],
  templateUrl: './order-deleted.component.html',
  styleUrl: './order-deleted.component.css',
})
export class OrderDeletedComponent {
  readonly order = input.required<Order>();
}
